module.exports = __webpack_public_path__ + "img/178.397f0b2c.jpg";